function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarksolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_170_2485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#38C793",
    style: {
      fill: "#38C793",
      fill: "color(display-p3 0.2196 0.7804 0.5765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5595 11.247L14.5595 18.247C14.5189 18.2877 14.4706 18.32 14.4175 18.342C14.3644 18.364 14.3075 18.3753 14.25 18.3753C14.1925 18.3753 14.1356 18.364 14.0825 18.342C14.0294 18.32 13.9811 18.2877 13.9405 18.247L10.878 15.1845C10.7959 15.1024 10.7498 14.9911 10.7498 14.875C10.7498 14.7589 10.7959 14.6476 10.878 14.5655C10.9601 14.4834 11.0714 14.4373 11.1875 14.4373C11.3036 14.4373 11.4149 14.4834 11.497 14.5655L14.25 17.319L20.9405 10.628C21.0226 10.5459 21.1339 10.4998 21.25 10.4998C21.3661 10.4998 21.4774 10.5459 21.5595 10.628C21.6416 10.7101 21.6877 10.8214 21.6877 10.9375C21.6877 11.0536 21.6416 11.1649 21.5595 11.247Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarksolid);
export default __webpack_public_path__ + "static/media/checkmarksolid.c3b6293722b287e9816607deb7b918f1.svg";
export { ForwardRef as ReactComponent };